"use client";
import { motion } from "framer-motion";
import Image from "next/legacy/image";
import StatsSection from "./StatsSection";

export default function IntroSection() {
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 2.5 } },
  };

  return (
    <motion.section
      className="bg-gradient-to-r from-[#00063A] via-[#425fae] to-[#00063A] text-left text-white"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={sectionVariants}
    >
      <div className="min-h-screen bg-gradient-to-r from-[#00063A] via-[#425fae] to-[#00063A] text-white flex flex-col md:flex-row items-center justify-between p-6 sm:p-12 relative">
        {/* Background Image */}
        <Image
          src="/Group.png"
          alt="bg-image"
          layout="fill"
          priority={100}
          className="object-cover top-0 bottom-0 z-0 opacity-30"
        />

        {/* Text Content (Left Side) */}
        <div className="md:w-1/2 space-y-4 sm:space-y-6 relative z-10 px-2 sm:px-0">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">
            Guiding Businesses into the Future:
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed">
            At Exponent Solutions, we empower businesses to embrace the future
            through innovative AI, machine learning, and data science solutions. Our
            mission is to guide your digital transformation by modernizing legacy
            systems and integrating intelligent technologies. We provide strategic
            consulting that helps you reimagine your operations, harnessing the
            power of automation and advanced analytics to drive transformative
            growth and maintain a competitive edge in a rapidly evolving
          </p>

          <div className="flex w-full justify-start">
            <div className="relative inline-flex group">
              <div className="absolute transition-all duration-1000 opacity-70 -inset-px bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-md blur-lg group-hover:opacity-100 group-hover:-inset-1 group-hover:duration-200 animate-tilt"></div>
              <a
                href="/who-we-are"
                title="Get quote now"
                className="relative inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-base sm:text-lg font-bold text-gray-300 transition-all duration-200 bg-[rgb(125,117,208)] font-pj rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
                role="button"
              >
                Get it now
              </a>
            </div>
          </div>
        </div>

        {/* Image (Right Side) */}
        <div className="w-full lg:w-1/2 mt-8 sm:mt-12 lg:mt-0 lg:pl-8 flex justify-center lg:justify-end relative z-10">
          <Image
            src="/Group 10.png"
            alt="Business Technology Illustration"
            width={400}
            height={500}
            className="object-contain max-h-[300px] sm:max-h-[400px] lg:max-h-[600px] w-auto"
          />
        </div>
      </div>
      <div className="mt-6 sm:mt-12 bg-black">
        <StatsSection />
      </div>
    </motion.section>
  );
}